// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  // apiKey: "AIzaSyCMxU6Rm6SS2oYlMTd1pDiXuNahAwrPP0Y",
  // authDomain: "passangerapp-1557997456806.firebaseapp.com/",
  // projectId: "passangerapp-155799745680",
  // storageBucket: "passangerapp-1557997456806.firebasestorage.app",
  // messagingSenderId: "217761503470",
  // appId: "1:217761503470:web:646d4a32ed89f7d44d7bff"
  apiKey: "AIzaSyCJheRe19DgBqiUM34Zy-2D8MlCjVa4_Pk",
  authDomain: "mobitill-booking-6f233.firebaseapp.com",
  projectId: "mobitill-booking-6f233",
  storageBucket: "mobitill-booking-6f233.firebasestorage.app",
  messagingSenderId: "741651590956",
  appId: "1:741651590956:web:d9cc5e1924d9d6d9790689",
  measurementId: "G-TR73Q7P4BD"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export default app;